import React from "react";
import Hero from "../components/Hero";
import Capabilities from "../components/Capabilities";
import HowItWorks from "../components/HowItWorks";
import Security from "../components/Security";
import CircularityServices from "../components/Circularity";
import MobileApp from "../components/MobileApp";
import ProvenResults from "../components/ProvenResults";
import CTASection from "../components/CTASection";
import Footer from "./Footer";
import ScrollToTop from "../components/ScrollToTop";
import EUCompliant from "../components/Eucompliant ";
import FAQ from "../components/FAQ";
import Pricing from "../components/Pricing";
import BatteryPassportSection from "../components/BatteryPassportSection";
// import BrandsAndConsumers from "../components/BrandsAndConsumers";
import WhyBatteriesFirst from "../components/WhyBatteriesFirst";   
import DashboardMockup from "../components/DashboardMockup";       
import MarketWeServe from "../components/MarketWeServe";           
 

const Home = () => {
  return (
    <div className="pt-20">
      <Hero />
      {/* <Capabilities /> */}
       <DashboardMockup /> 
      <HowItWorks />
      {/* <EUCompliant /> */}
      <WhyBatteriesFirst />   
     
      {/* <BatteryPassportSection /> */}
      <Security />
      <CircularityServices />
      <MobileApp />
          {/* <BrandsAndConsumers /> */}
      <MarketWeServe />  
      {/* <ProvenResults /> */}
      <Pricing />
      <FAQ />
      <CTASection />
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default Home;
